// Full URL for a media reference.
// New media is stored as absolute DigitalOcean Spaces URLs; any legacy value is a
// relative path (uploads/...) still served from the API host.
export default function mediaUrl(u) {
	if (!u) return "";
	if (/^https?:\/\//.test(u)) return u;
	const base = process.env.REACT_APP_API_URL || "";
	return `${base}${u.startsWith("/") ? u.slice(1) : u}`;
}
